import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = {
  class: "d-flex flex-column bgi-no-repeat rounded-top",
  style: {"background-image":"url('media/misc/pattern-1.jpg')"}
}
const _hoisted_3 = { class: "text-white fw-bold px-9 mt-10 mb-6" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Notifications ")
const _hoisted_5 = { class: "fs-8 opacity-75 ps-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link text-white opacity-75 opacity-state-100 pb-4a active",
      "data-bs-toggle": "tab",
      href: "#kt_topbar_notifications_1"
    }, "Alerts")
  ])
], -1)
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = {
  class: "tab-pane fade active show",
  id: "kt_topbar_notifications_1",
  role: "tabpanel"
}
const _hoisted_9 = { class: "scroll-y mh-325px my-5 px-8" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "symbol symbol-35px me-4" }
const _hoisted_12 = { class: "mb-0 me-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-gray-400 fs-7" }
const _hoisted_15 = { class: "py-3 text-center border-top" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" View All ")
const _hoisted_17 = { class: "svg-icon svg-icon-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(_ctx.tableData.length) + ")", 1)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "d-flex flex-stack py-4"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: _normalizeClass([`bg-light-primary`, "symbol-label"])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([`svg-icon-primary`, "svg-icon svg-icon-2"])
                    }, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr024.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.viewNotification(item)),
                    class: "fs-6 text-gray-800 text-hover-primary fw-bolder cursor-pointer"
                  }, _toDisplayString(item.title), 9, _hoisted_13),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.message), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: "/notification/notification-listing",
            class: "btn btn-color-gray-600 btn-active-color-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}